import { noop } from "@vueuse/core";
import type { InjectionKey, Plugin } from "vue";

type ProvidedConfirmationMethods = {
  toggleDiscardChanges: () => Promise<boolean>;
  isDirty: () => boolean;
};

export const provideConfirmationMethodsKey: InjectionKey<
  (confirmationMethods: ProvidedConfirmationMethods) => void
> = Symbol("provideConfirmationMethodsKey");

export const discardConfirmationKey: InjectionKey<ProvidedConfirmationMethods> =
  Symbol("discardConfirmationKey");

export const registerConfirmation: Plugin = {
  install(app) {
    app.provide(provideConfirmationMethodsKey, confirmationMethods => {
      const { toggleDiscardChanges, isDirty } = confirmationMethods;
      toggleDiscardChangesCb = toggleDiscardChanges;
      isDirtyCb = isDirty;
    });

    let toggleDiscardChangesCb = noop as () => Promise<boolean>;
    let isDirtyCb = noop as () => boolean;
    app.provide(discardConfirmationKey, {
      toggleDiscardChanges: () => toggleDiscardChangesCb(),
      isDirty: () => isDirtyCb()
    });
  }
};
